import { FormTemplate } from "components/modal/templates";
import { dateToView } from "helpers/date";
import React from "react";
import { getDriverLicense, setDriverLicense } from "sources/books/drivers";
import { getLicenseConfig } from "./show/formConfig";

export default class DriverLicenseModal extends FormTemplate {
    componentDidMount() {
        const id = this.props.id || this.props.driverId;
        if (id) {
            getDriverLicense(id).then((data) => {
                this.setState({ isLoading: false, isValid: true, ...(data || {}) });
            });
        } else {
            this.setState({ isLoading: false, isValid: true });
        }
    }

    getValidationConfig = (state) => {
        return getLicenseConfig(state?.issuingCountry, state?.series, state?.number, state?.dateOfIssue);
    };

    setValue = ({ name, value }) => {
        const formattedValue =
            (name === "series" || name === "number") && typeof value === "string" ? value.toUpperCase() : value;
        const nextState = { ...this.state, [name]: formattedValue };
        const isValid = this.isValidForm(nextState);
        this.setState({ [name]: formattedValue, ...(isValid ? { isValid: true } : {}) });
    };

    sendRequest = (stateData) => {
        const id = this.props.id || this.props.driverId;
        if (!id) {
            return Promise.resolve(false);
        }
        const data = {
            ...stateData,
            driverId: id,
            dateOfIssue: stateData.dateOfIssue
                ? dateToView(stateData.dateOfIssue, "YYYY-MM-DD")
                : stateData.dateOfIssue,
            expirationDate: stateData.expirationDate
                ? dateToView(stateData.expirationDate, "YYYY-MM-DD")
                : stateData.expirationDate,
        };
        return setDriverLicense(data);
    };

    renderBodyInner = () => {
        const { issuingCountry, series, number, dateOfIssue, expirationDate } = this.getValidationConfig(this.state);
        return (
            <>
                {this.renderSelect(issuingCountry)}
                {this.renderField(series)}
                {this.renderField(number)}
                {this.renderDateField(dateOfIssue)}
                {this.renderDateField(expirationDate)}
            </>
        );
    };
}
